import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import Const from '../defs/const';

// const MYHOST = 'http://localhost:3000';
// Const.MYHOST.replace('localhost', window.location.hostname);
const MYHOST = (window.location.toString().indexOf('http://localhost:3001') === 0) ? 'http://localhost:3000' : Const.MYHOST || 'http://localhost:3000';

export const api = createApi({
	baseQuery: fetchBaseQuery({
		baseUrl: `${MYHOST}/api`,
		prepareHeaders: (headers, { getState }) => {
			const token = getState().auth.jwt;
			if (token) headers.set('Authorization', `Bearer ${token}`);
			headers.set('Accept', 'application/json');
			return headers;
		},
	}),
	tagTypes: [
		'Books',
		'Author',
		'Actor',
		'Category',
		'User',
		'ProfileAttachment',
		'EmailTemplate',
	],
	endpoints: (builder) => ({
		login: builder.mutation({
			query: (credentials) => ({
				url: `/auth/${Const.URL_API_SIGN_IN}`,
				method: 'POST',
				body: credentials,
			}),
		}),

		signup: builder.mutation({
			query: (credentials) => ({
				url: `/auth/${Const.URL_API_SIGN_UP}`,
				method: 'POST',
				body: credentials,
			}),
		}),
		addImg: builder.mutation({
			query: (credentials) => ({
				url: `/auth/${Const.URL_API_ADD_IMAGE}`,
				method: 'POST',
				body: credentials,
			}),
		}),

		getAuthors: builder.query({
			query: () => ({
				url: '/author',
				method: 'GET',
			}),
			providesTags: [{ type: 'Author', id: 'author' }],
		}),

		getActors: builder.query({
			query: () => ({
				url: '/actor',
				method: 'GET',
			}),
			providesTags: [{ type: 'Actor', id: 'actor' }],
		}),

		getCategories: builder.query({
			query: () => ({
				url: '/category',
				method: 'GET',
			}),
			providesTags: [{ type: 'Category', id: 'categories' }],
		}),

		getBookArchiveLink: builder.query({
			query: (id) => ({
				url: `${Const.URL_BOOK_GET}/downloadBook/${id}`,
				method: 'GET',
			}),
		}),

		getBooks: builder.query({
			query: (arg) => ({
				url: Const.URL_BOOK_GET,
				method: 'GET',
				params: arg,
			}),
			providesTags: [
				{ type: 'Books', id: 'LIST' },
				{ type: 'Author', id: 'author' },
			],
		}),

		getBookDetails: builder.query({
			query: (id) => ({
				url: `${Const.URL_BOOK_GET}/${id}`,
				method: 'GET',
			}),
			providesTags: [
				{ type: 'Books', id: 'LIST' },
				{ type: 'Author', id: 'author' },
				{ type: 'Actor', id: 'actor' },
				{ type: 'Category', id: 'category' },
			],
		}),

		getCanAddBooks: builder.query({
			query: (params) => ({
				url: `${Const.URL_BOOK_GET}/canAdd`,
				method: 'GET',
				params,
			}),
			providesTags: [{ type: 'Books', id: 'LIST' }],
		}),

		postAddBook: builder.mutation({
			query: (credentials) => ({
				url: `${Const.URL_BOOK_GET}/add`,
				method: 'POST',
				body: credentials,
			}),
			invalidatesTags: [{ type: 'Books', id: 'LIST' }],
		}),

		getMyBooks: builder.query({
			query: (arg) => ({
				url: `${Const.URL_BOOK_GET}/mybooks`,
				method: 'GET',
				params: arg,
			}),
			providesTags: [{ type: 'Books', id: 'LIST' }],
		}),

		getMe: builder.query({
			query: () => ({
				url: `auth/me`,
				method: 'GET',
			}),
		}),

		postChangePassword: builder.mutation({
			query: (credentials) => ({
				url: 'auth/change-password',
				method: 'POST',
				body: credentials,
			}),
		}),

		postForgotPassword: builder.mutation({
			query: (credentials) => ({
				url: 'auth/forgot-password',
				method: 'POST',
				body: credentials,
			}),
		}),

		postResetPassword: builder.mutation({
			query: (credentials) => ({
				url: 'auth/reset-password',
				method: 'POST',
				body: credentials,
			}),
		}),
		getFileLink: builder.query({
			query: (params) => ({
				url: `${Const.URL_BOOK_GET}/fileLink`,
				method: 'GET',
				params,
			}),
			keepUnusedDataFor: 60 * 60,
		}),
		postSendEmail: builder.mutation({
			query: (credentials) => ({
				url: 'user/contact',
				method: 'POST',
				body: credentials,
			}),
		}),

		getAdminAuthors: builder.query({
			query: (arg) => ({
				url: `admin/authors`,
				method: 'GET',
				params: arg,
			}),
			providesTags: [{ type: 'Author', id: 'author' }],
		}),

		deleteAuthor: builder.mutation({
			query: (arg) => ({
				url: `admin/authors/delete`,
				method: 'POST',
				body: arg,
			}),
			invalidatesTags: [{ type: 'Author', id: 'author' }],
		}),

		updateAuthor: builder.mutation({
			query: (arg) => ({
				url: `admin/authors/update`,
				method: 'PUT',
				body: arg,
			}),
			invalidatesTags: [{ type: 'Author', id: 'author' }],
		}),

		addAuthor: builder.mutation({
			query: (arg) => ({
				url: `admin/authors/create`,
				method: 'POST',
				body: arg,
			}),
			invalidatesTags: [{ type: 'Author', id: 'author' }],
		}),

		deleteActor: builder.mutation({
			query: (arg) => ({
				url: `admin/actors/delete`,
				method: 'POST',
				body: arg,
			}),
			invalidatesTags: [{ type: 'Actor', id: 'actor' }],
		}),

		updateActor: builder.mutation({
			query: (arg) => ({
				url: `admin/actors/update`,
				method: 'PUT',
				body: arg,
			}),
			invalidatesTags: [{ type: 'Actor', id: 'actor' }],
		}),

		addActor: builder.mutation({
			query: (arg) => ({
				url: `admin/actors/create`,
				method: 'POST',
				body: arg,
			}),
			invalidatesTags: [{ type: 'Actor', id: 'actor' }],
		}),

		getAdminActors: builder.query({
			query: (arg) => ({
				url: `admin/actors`,
				method: 'GET',
				params: arg,
			}),
			providesTags: [{ type: 'Actor', id: 'actor' }],
		}),

		getAdminCategories: builder.query({
			query: (arg) => ({
				url: `admin/categories`,
				method: 'GET',
				params: arg,
			}),
			providesTags: [{ type: 'Category', id: 'category' }],
		}),

		deleteCategory: builder.mutation({
			query: (arg) => ({
				url: `admin/categories/delete`,
				method: 'POST',
				body: arg,
			}),
			invalidatesTags: [{ type: 'Category', id: 'category' }],
		}),

		updateCategory: builder.mutation({
			query: (arg) => ({
				url: `admin/categories/update`,
				method: 'PUT',
				body: arg,
			}),
			invalidatesTags: [{ type: 'Category', id: 'category' }],
		}),

		addCategory: builder.mutation({
			query: (arg) => ({
				url: `admin/categories/create`,
				method: 'POST',
				body: arg,
			}),
			invalidatesTags: [{ type: 'Category', id: 'category' }],
		}),

		getStats: builder.query({
			query: (arg) => ({
				url: `admin/stats`,
				method: 'GET',
				params: arg,
			}),
		}),

		getMonthlyDownloads: builder.query({
			query: (arg) => ({
				url: `admin/stats/monthlyDownloads/?year=${arg}`,
				method: 'GET',
			}),
		}),

		getMonthlyDownloadsUsers: builder.query({
			query: (arg) => ({
				url: `admin/stats/monthlyDownloadsUsers/?year=${arg}`,
				method: 'GET',
			}),
		}),

		getMonthlyDownloadsBooks: builder.query({
			query: (arg) => ({
				url: `admin/stats/monthlyDownloadsBooks/?year=${arg}`,
				method: 'GET',
			}),
		}),

		// ... other endpoints
		addAdminBook: builder.mutation({
			query: (formData) => ({
				url: 'admin/book/create',
				method: 'POST',
				body: formData,
			}),
			invalidatesTags: [{ type: 'Books', id: 'LIST' }],
		}),
		// ... remaining endpoints

		updateAdminBook: builder.mutation({
			query: (formData) => ({
				url: `admin/book/update`,
				method: 'PUT',
				body: formData,
			}),
			invalidatesTags: [{ type: 'Books', id: 'LIST' }],
		}),

		getBooksCSV: builder.query({
			query: () => ({
				url: `admin/book/csv`,
				method: 'GET',
			}),
		}),

		getAllUsers: builder.query({
			query: (arg) => ({
				url: `admin/users`,
				method: 'GET',
				params: arg,
			}),
			providesTags: [{ type: 'User', id: 'user' }],
		}),

		getUserDetails: builder.query({
			query: (arg) => ({
				url: `admin/users/details`,
				method: 'GET',
				params: arg,
			}),
			providesTags: [{ type: 'User', id: 'user' }],
		}),

		deleteUser: builder.mutation({
			query: (arg) => ({
				url: `admin/users/delete`,
				method: 'POST',
				body: arg,
			}),
			invalidatesTags: [{ type: 'User', id: 'user' }],
		}),

		// apiSlice.js excerpt
		getProfileAttachments: builder.query({
			query: (userId) => ({
				url: `admin/profile-attachments/${userId}`,
				method: 'GET',
			}),
			providesTags: [{ type: 'ProfileAttachment', id: 'LIST' }],
		}),

		deleteProfileAttachment: builder.mutation({
			query: (attachmentId) => ({
				url: `admin/profile-attachments/${attachmentId}`,
				method: 'DELETE',
			}),
			invalidatesTags: [{ type: 'ProfileAttachment', id: 'LIST' }],
		}),

		updateUser: builder.mutation({
			query: (formData) => ({
				url: `admin/users/update`,
				method: 'PUT',
				body: formData,
			}),
			invalidatesTags: [{ type: 'User', id: 'user' }],
		}),

		deleteBookAttachment: builder.mutation({
			query: (attachmentId) => ({
				url: `admin/book/book-attachments/${attachmentId}`,
				method: 'DELETE',
			}),
			invalidatesTags: [{ type: 'Books', id: 'LIST' }],
		}),

		createBookArchive: builder.mutation({
			query: (bookId) => ({
				url: `admin/book/archive/${bookId}`,
				method: 'POST',
			}),
			invalidatesTags: [{ type: 'Books', id: 'LIST' }],
		}),

		deleteBookArchive: builder.mutation({
			query: (bookId) => ({
				url: `admin/book/archive/${bookId}`,
				method: 'DELETE',
			}),
			invalidatesTags: [{ type: 'Books', id: 'LIST' }],
		}),

		getAdminBookArchiveMonitor: builder.query({
			query: () => ({
				url: 'admin/book/archive-monitor',
				method: 'GET',
			}),
		}),

		deleteBook: builder.mutation({
			query: (arg) => ({
				url: `admin/book/delete`,
				method: 'POST',
				body: arg,
			}),
			invalidatesTags: [{ type: 'Books', id: 'LIST' }],
		}),

		getBookReferencesCount: builder.mutation({
			query: (arg) => ({
				url: `admin/book/references-count`,
				method: 'POST',
				body: arg,
			}),
		}),

		getEmailTemplates: builder.query({
			query: () => ({
				url: 'admin/email-templates',
				method: 'GET',
			}),
			providesTags: [{ type: 'EmailTemplate', id: 'LIST' }],
		}),

		updateEmailTemplate: builder.mutation({
			query: ({ id, text }) => ({
				url: `admin/email-templates/${id}`,
				method: 'PUT',
				body: { text },
			}),
			invalidatesTags: [{ type: 'EmailTemplate', id: 'LIST' }],
		}),
	}),
});

export const {
	useUpdateEmailTemplateMutation,
	useGetEmailTemplatesQuery,
	useDeleteBookAttachmentMutation,
	useCreateBookArchiveMutation,
	useDeleteBookArchiveMutation,
	useGetAdminBookArchiveMonitorQuery,
	useDeleteBookMutation,
	useGetBookReferencesCountMutation,
	useGetProfileAttachmentsQuery,
	useDeleteProfileAttachmentMutation,
	useGetUserDetailsQuery,
	useDeleteUserMutation,
	useUpdateUserMutation,
	useGetAllUsersQuery,
	useGetBooksCSVQuery,
	useUpdateAdminBookMutation,
	useAddAdminBookMutation,
	useGetBookArchiveLinkQuery,
	useLoginMutation,
	useSignupMutation,
	useAddImgMutation,
	useGetBooksQuery,
	useGetAuthorsQuery,
	useGetActorsQuery,
	useGetCategoriesQuery,
	usePrefetch,
	useGetBookDetailsQuery,
	useGetCanAddBooksQuery,
	usePostAddBookMutation,
	useGetMyBooksQuery,
	useGetMeQuery,
	usePostChangePasswordMutation,
	usePostForgotPasswordMutation,
	usePostResetPasswordMutation,
	useGetFileLinkQuery,
	usePostSendEmailMutation,
	useGetAdminAuthorsQuery,
	useDeleteAuthorMutation,
	useUpdateAuthorMutation,
	useAddAuthorMutation,
	useAddActorMutation,
	useDeleteActorMutation,
	useUpdateActorMutation,
	useGetAdminActorsQuery,
	useAddCategoryMutation,
	useDeleteCategoryMutation,
	useGetAdminCategoriesQuery,
	useUpdateCategoryMutation,
	useGetStatsQuery,
	useGetMonthlyDownloadsQuery,
	useGetMonthlyDownloadsUsersQuery,
	useGetMonthlyDownloadsBooksQuery,
} = api;
